module.exports = __webpack_public_path__ + "img/MES11Indice3_cutout.6fcd4661.png";